const getWaitInfo = flight => {
  const waitIconMap = {
    stop_message: 'PauseCircleOutlineIcon',
    airport_change_message: 'ErrorOutlineIcon',
    default_message: 'AccessTimeIcon',
  };

  const messageKey = Object.keys(waitIconMap).find(key => flight[key]);
  const waitIcon = messageKey ? waitIconMap[messageKey] : 'AccessTimeIcon';

  return {
    type: 'wait',
    waitIcon,
    data: {
      message: messageKey ? flight[messageKey] : '',
    },
  };
};

export const processFlights = flights =>
  flights.flatMap((flight, index) => {
    const items = [{ type: 'flight', data: flight }];

    if (index < flights.length - 1) {
      items.push(getWaitInfo(flight));
    }

    return items;
  });
